import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Carousel, Col, Form, Input, message, Row, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import image1 from "../assets/image1.svg";
import image2 from "../assets/image2.svg";
import logo from "../assets/logo.png";
import CustomButton from "../common/CustomButton";
import AuthService from "../services/Auth/AuthService";

const { Title, Text } = Typography;

function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleForgotPassword = (email) => {
    setLoading(true);
    AuthService.generateOtp({ email })
      .then((response) => {
        if (response.status === 200) {
          message.info("OTP Sent to your email.");
          setEmail(email);
          setIsOtpSent(true);
        } else {
          message.error(response.message || "Failed to send OTP");
        }
      })
      .catch((error) => {
        message.error(error.message || "An unexpected error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResetPassword = (email, otp, newPassword) => {
    setLoading(true);

    AuthService.forgotPassword({ email, otp, newPassword })
      .then((response) => {
        if (response.status === 200) {
          message.info("Password reset successfully.");
          navigate("/login");
        } else {
          message.error(response.message || "Failed to reset password");
        }
      })
      .catch((error) => {
        message.error(error.message || "An unexpected error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    if (isOtpSent) {
      handleResetPassword(email, otp, newPassword);
    } else {
      handleForgotPassword(email);
    }
  };

  const handleNavigate = () => {
    navigate("/login");
  };

  return (
    <Row className="h-screen overflow-hidden">
      <Col
        xs={24}
        md={12}
        className="flex items-center justify-center h-full overflow-auto"
      >
        <div className="relative w-full max-w-lg p-8 bg-white shadow-2xl rounded-xl transition-transform duration-700">
          <div className="text-center mb-6">
            <img
              src={logo}
              alt="Conti Logo"
              className="demo-logo-vertical text-center w-3/5"
            />
            <Title level={4}>
              {isOtpSent ? "Reset Password" : "Forgot Password"}
            </Title>
            <Text className="text-tertiary">
              {isOtpSent
                ? "Enter the OTP and your new password"
                : "Enter your email to reset your password"}
            </Text>
          </div>
          <Form
            name={isOtpSent ? "resetPassword" : "forgotPassword"}
            layout="vertical"
          >
            {!isOtpSent ? (
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please input your email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="Email Address"
                  className="rounded-md p-3"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Item>
            ) : (
              <>
                <Form.Item
                  name="otp"
                  rules={[{ required: true, message: "Please input the OTP" }]}
                >
                  <Input
                    prefix={<LockOutlined />}
                    placeholder="Enter OTP"
                    className="rounded-md p-3"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </Form.Item>
                <Form.Item
                  name="newPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input your new password",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="New Password"
                    className="rounded-md p-3"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Form.Item>
              </>
            )}
            <CustomButton
              type="primary"
              onClick={handleSubmit}
              className={`w-full h-11 bg-primary hover:!bg-teal-500 rounded-md ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={loading}
            >
              {loading
                ? "Loading..."
                : isOtpSent
                  ? "Reset Password"
                  : "Send OTP"}
            </CustomButton>
            <div className="text-center mt-3">
              <Text>Already Registered?</Text>
              <Text
                className="text-primary ml-1 hover:text-teal-500 cursor-pointer"
                onClick={handleNavigate}
              >
                Login
              </Text>
            </div>
          </Form>
        </div>
      </Col>

      <Col xs={0} md={12} className="hidden md:flex h-screen">
        <div className="relative h-full w-full">
          <Carousel
            dotPosition="top"
            autoplay
            autoplaySpeed={8000}
            speed={2000}
          >
            <img src={image1} alt="image1" />
            <img src={image2} alt="image2" />
          </Carousel>
        </div>
      </Col>
    </Row>
  );
}

export default ForgotPassword;
